module.exports = __webpack_public_path__ + "img/pic-paging-aiot-4.28f1b98f.jpg";